import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  centered?: boolean;
  withGlow?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  centered = false,
  withGlow = true,
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-12 h-12 border-3',
    xl: 'w-16 h-16 border-4',
  };

  const glowClass = withGlow ? 'shadow-glow' : '';

  const spinner = (
    <div
      className={`${sizeClasses[size]} border-neon-red border-t-transparent rounded-full animate-spin ${glowClass} ${className}`}
      role="status"
      aria-label="Betöltés..."
    >
      <span className="sr-only">Betöltés...</span>
    </div>
  );

  if (centered) {
    return (
      <div className="flex items-center justify-center w-full h-full min-h-[200px]">
        {spinner}
      </div>
    );
  }

  return spinner;
};
